/** Redirect unauthenticated admin visits to wa-account-v2 auth entry (?app=admin). */

import { normalizeAuthAppUrl } from "./auth-app-url.util";

const AUTHORIZATION_DATA_KEY = "authorizationData";

export function buildAdminAuthEntryUrl(
  env: { authAppUrl?: string; loginUrl?: string },
  options?: { loggedOut?: boolean; handoffFailed?: boolean }
): string {
  const base = normalizeAuthAppUrl(
    env.authAppUrl?.trim() || env.loginUrl?.trim() || ""
  );
  const login = new URL(`${base}/`);
  login.searchParams.set("app", "admin");
  if (options?.loggedOut) {
    login.searchParams.set("loggedOut", "1");
  }
  if (options?.handoffFailed) {
    login.searchParams.set("handoffFailed", "1");
  }
  return login.href;
}

function hasStoredAuthSession(): boolean {
  if (typeof localStorage === "undefined") {
    return false;
  }
  try {
    return !!localStorage.getItem(AUTHORIZATION_DATA_KEY)?.trim();
  } catch {
    return false;
  }
}

function isAuthHandoffRoute(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const path = window.location.pathname.toLowerCase();
  if (!path.includes("/app-redirect")) {
    return false;
  }
  const url = new URL(window.location.href);
  return !!(
    url.searchParams.get("token")?.trim() ||
    url.searchParams.get("q")?.trim()
  );
}

/**
 * Before Angular bootstraps, send users with no local session to dev-auth/?app=admin.
 * Returns true when a full-page redirect was started.
 */
export function redirectToAdminAuthIfUnauthenticated(env: {
  authAppUrl?: string;
  loginUrl?: string;
}): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  if (isAuthHandoffRoute()) {
    return false;
  }
  if (hasStoredAuthSession()) {
    return false;
  }

  const target = buildAdminAuthEntryUrl(env);
  if (!target.startsWith("http")) {
    return false;
  }

  window.location.replace(target);
  return true;
}
